// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3iXHD","modal":"Modal_modal__30MRu","slide-down":"Modal_slide-down__294fH"};